import { render, staticRenderFns } from "./bs_supplier_select.vue?vue&type=template&id=4b37d287&"
import script from "./bs_supplier_select.vue?vue&type=script&lang=coffee&"
export * from "./bs_supplier_select.vue?vue&type=script&lang=coffee&"
import style0 from "./bs_supplier_select.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports